import { Card, CardBody, Col,} from "reactstrap";
import { P } from "../../../../../AbstractElements";
import { dateConversion } from "../../../../../utils/dateUtils";
import MobileEditButton from "../../../../../CommonElements/MobileEditButton";
import {
  approvalAttendanceModal,
  danger,
  infoColor,
  InTime,
  OutTime,
  secondary,
  Status,
  success,
  warningColor,
  WorkingHours,
} from "../../../../../utils/Constant";
import BadgeDetails from "../../../../../CommonElements/Badge/BadgeDetails";
import {
  convertTo12HourFormat,
  getTimeDifference,
} from "../../../../../utils/timeUtils";
import { ModalType } from "../../../../../Types/UserProfileDetails";
import { useInViewPort } from "../../../../../hooks/useInViewport";
import { IAttendanceRequestData } from "../../types";
import "../../../../attendance/attendance.scss";
import SkeletonLoader from "../../../../../CommonElements/Loader/SkeletonLoader";

export interface ITeamMembersAttendanceCardProps {
  index: number;
  teamMemberAttendanceLoading: boolean;
  teamMembersAttendance: IAttendanceRequestData;
  openModal: (modalType: ModalType, attendanceRequestId: number) => void;
}

const TeamMembersAttendanceCard = ({
  openModal,
  teamMembersAttendance,
  index,
  teamMemberAttendanceLoading,
}: ITeamMembersAttendanceCardProps) => {
  const { observerRef, inView } = useInViewPort<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <Col xs="12" sm="6" xl="4" xxl="4" key={index}>
      <Card
        className={`${inView ? "fadeInUp animate" : "opacity-0"}`}
        innerRef={observerRef}
      >
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-2">
            {teamMemberAttendanceLoading ? (
              <SkeletonLoader className="w-50 me-4" />
            ) : (
              <P className="m-0 f-12">
                {dateConversion(teamMembersAttendance?.date, true)}
              </P>
            )}
            {teamMemberAttendanceLoading ? (
              <SkeletonLoader className="w-50 ms-4" />
            ) : (
              <MobileEditButton
                handleOnClick={() =>
                  openModal(
                    approvalAttendanceModal,
                    teamMembersAttendance.attendance_request_id
                  )
                }
              />
            )}
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            {teamMemberAttendanceLoading ? (
           <SkeletonLoader className="w-50 me-4" />
            ) : (
              <P className="m-0 f-12 text-start w-50">
                {teamMembersAttendance?.team_member?.name}
              </P>
            )}
            {teamMemberAttendanceLoading ? (
            <SkeletonLoader className="w-50 ms-4" />
            ) : (
              <P className="m-0 f-12 text-start w-50 text-wrap">
                {teamMembersAttendance?.team_member?.email}
              </P>
            )}
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div>
              <BadgeDetails
                color={success}
                className="badget-success"
                badgeHeading={InTime}
                loading={teamMemberAttendanceLoading}
                text={convertTo12HourFormat(
                  teamMembersAttendance?.in_time ?? ""
                )}
              />
            </div>
            <div>
              <BadgeDetails
                color={infoColor}
                className="badget-info"
                badgeHeading={OutTime}
                loading={teamMemberAttendanceLoading}
                text={convertTo12HourFormat(
                  teamMembersAttendance?.out_time ?? ""
                )}
              />
            </div>
            <div>
              <BadgeDetails
                color={secondary}
                className="badget-info"
                badgeHeading={WorkingHours}
                loading={teamMemberAttendanceLoading}
                text={getTimeDifference(
                  teamMembersAttendance?.in_time ?? "",
                  teamMembersAttendance?.out_time ?? ""
                )}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <BadgeDetails
                color={warningColor}
                className="badget-info"
                badgeHeading={Status}
                loading={teamMemberAttendanceLoading}
                text={teamMembersAttendance?.status}
              />
            </div>
          </div>
          <div className="d-flex flex-column align-items-start text-start">
            <BadgeDetails
              color={danger}
              className="badget-info"
              badgeHeading={Status}
              loading={teamMemberAttendanceLoading}
              text={teamMembersAttendance?.reason}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TeamMembersAttendanceCard;
